// @flow
import { Price } from '@model/Price';
import { SubcategoryType } from '@model/Subcategory';
import { ImageObject } from '@packages/image/lib/types';
import * as Yup from 'yup';
import { AddOn, AddOnType } from './AddOn';
import { Model, ModelClassType } from './Model';
import { SkuType } from './Sku';

export interface PackageType extends ModelClassType {
    id: number;
    name: string;
    page_title: string;
    meta_keywords: string;
    slug: string;
    short_description: string;
    description: string;
    image_id: number;
    image: ImageObject;
    subcategory_ids: number[];
    selectable_sku_ids: any[];
    selectable_skus: SkuType[];
    customer_price: string;
    published: boolean;
    prices: any[];
    subcategories: SubcategoryType[];
    customer_custom_prices: Price[];
    minimum_order_quantity: number;
    international_minimum_order_quantity: number;
    yotpo_review: string;
    addons: AddOnType[];
    addon_ids: [];
    is_shipping_method_available: boolean;
    shipping_method_ids: [];
}

export const Package = Model<PackageType>('Package', {
    endpoint: 'apparel-packages',
})`
    id:Int;
    name:String;
    slug:String;
    subcategory:String;
    subcategory_ids: any;
    page_title:String;
    meta_keywords:String;
    short_description:String;
    description:String;
    category_id:Int;
    category:Any;
    customer_price:String;
    image_id:Int;
    image:Any;
    selectable_sku_ids:Any;
    selectable_skus:Any;
    published:Boolean;
    prices:Any;
    minimum_order_quantity:Int;
    international_minimum_order_quantity:Int;
    yotpo_review:String;
    addons: ${AddOn};
    addon_ids:Any;
    is_shipping_method_available:boolean;
    shipping_method_ids:Any;
`;

export const PackageValidation = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    page_title: Yup.string().max(100, 'Page title must be at most 100 characters'),
    short_description: Yup.string().max(400, 'Short description must be at most 400 characters'),
});
